export default __webpack_public_path__ + "static/media/Tick.61601067.svg";